'use client';
import React from 'react';
import styled from 'styled-components';
import { useMapContext } from '../../../contexts/map-context'; // Import the context hook
import Image from 'next/image';

const ToggleWrapper = styled.div`
    top: 7.5rem;
    right: 2rem; /* Default for desktops */
    border-radius: 5px;
    width: 250px;
    padding: .5rem 0;
    font-size: 16px;

    @media (max-width: 1024px) {
        top: 20rem;
        left: 10rem; /* Align with FilterPanel on tablets */
        right: auto;
    }

    @media (max-width: 768px) {
        top: 30rem;
        left: 2rem; /* Align with FilterPanel on mobile */
        right: auto;
    }

    @media (max-width: 480px) {
        top: 33rem;
        left: 1.2rem; /* Align with FilterPanel on smaller mobile */
        right: auto;
    }
`;

const CheckText = styled.p`
    color: white !important;

    &:hover {
        color: #d99e63 !important;
    }
`;

export const ToggleMultiSelect = () => {
    const { state, dispatch } = useMapContext(); // Use the context

    const setMultiSelect = (value: boolean) => {
        dispatch({ type: 'UPDATE_MULTI_SELECT', payload: { newValue: value } });
    };

    return (
        <ToggleWrapper className='absolute flex justify-center items-center'>
            <div
                className={`flex items-center cursor-pointer mb-0 p-4 rounded-lg bg-[#130F0FCC]`}
                onClick={() => setMultiSelect(!state.multiSelect)}
            >
                <div className="flex items-center justify-center mr-2">
                    <button className={`border  w-5 h-5 flex items-center justify-center hover:opacity-80 ${state.multiSelect ? 'bg-orange-500' : 'bg-white'}`}>
                        {state.multiSelect ? (
                            <Image src={'/images/map/icons/check.svg'} alt="Selected Icon" width={100} height={100} />
                        ) : null}
                    </button>
                </div>
                <CheckText className={`text-white`}>Multiselect Minting</CheckText>
            </div>
        </ToggleWrapper>
    );
};